import React from 'react';
import SimpleTextarea from 'src/components/SimpleTextarea';
import PropTypes from 'prop-types';
import SimpleInput from 'src/components/SimpleInput';
import CustomMultiSelect from 'src/components/MessengerSettings/CustomMultiSelect';
import RadioGroup from 'src/pages/DeploymentCenter/components/RadioGroup';
import { chatgenieAPI } from 'src/config/api';
import SimpleCheckbox from 'src/components/SimpleCheckbox';
import { CustomSelectOption, IntentBlock, IntentField, IntentFieldGroup } from './style';

const CustomOption = props => {
  const { data, isSelected, label } = props;
  const id = `select-option-checkbox-${data.id}`;

  return (
    <CustomSelectOption {...props}>
      <div>
        <SimpleCheckbox htmlFor={id} id={id} checked={isSelected} readOnly />
        {label}
      </div>
      <span>{!data.is_magic_agent_enabled && 'Not enabled'}</span>
    </CustomSelectOption>
  );
};
CustomOption.propTypes = {
  data: PropTypes.object.isRequired,
  isSelected: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired
};

const VariationDetails = ({
  name,
  clients,
  isAllClients,
  isDefault,
  description,
  handleDescriptionChange,
  handleClientsChange,
  handleIsAllClientsChange,
  handleVariationNameChange
}) => (
  <IntentBlock>
    {isDefault ? (
      <div>
        <IntentFieldGroup>
          <IntentField>
            <p>Describe the intent</p>
            <SimpleTextarea
              value={description}
              rows={3}
              onChange={e => handleDescriptionChange(e.target.value)}
              placeholder="Describe the intent so the agent can recognize it and proceed with next steps. Eg. This intent is for users who are having printer issues"
            />
          </IntentField>

          <IntentField>
            <p>Who can see this</p>
            <RadioGroup
              value={!!isAllClients}
              options={[
                { label: 'All clients that have Magic Agents enabled', value: true },
                { label: 'Specific clients', value: false }
              ]}
              onChange={() => {
                handleIsAllClientsChange(!isAllClients);
              }}
            />
            {!isAllClients && (
              <>
                <p />
                <CustomMultiSelect
                  name="variation-clients"
                  value={clients}
                  options={(query, page) => chatgenieAPI.getAgentCompanies({ query, page })}
                  onChange={handleClientsChange}
                  componentType="paginate"
                  components={{
                    Option: CustomOption
                  }}
                />
              </>
            )}
          </IntentField>
        </IntentFieldGroup>
      </div>
    ) : (
      <IntentFieldGroup>
        <IntentField>
          <p>Name</p>
          <SimpleInput
            value={name}
            onChange={e => handleVariationNameChange(e.target.value)}
            placeholder="Name of the variation"
          />
        </IntentField>
        <IntentField>
          <p>Clients</p>
          <CustomMultiSelect
            name="variation-clients"
            value={clients}
            options={(query, page) => chatgenieAPI.getAgentCompanies({ query, page })}
            onChange={handleClientsChange}
            componentType="paginate"
            components={{
              Option: CustomOption
            }}
          />
        </IntentField>
      </IntentFieldGroup>
    )}
  </IntentBlock>
);

VariationDetails.propTypes = {
  name: PropTypes.string.isRequired,
  isDefault: PropTypes.bool.isRequired,
  description: PropTypes.string.isRequired,
  handleDescriptionChange: PropTypes.func.isRequired,
  handleVariationNameChange: PropTypes.func.isRequired,
  handleClientsChange: PropTypes.func.isRequired,
  handleIsAllClientsChange: PropTypes.func.isRequired,
  clients: PropTypes.arrayOf(PropTypes.object).isRequired,
  isAllClients: PropTypes.bool.isRequired
};

export default VariationDetails;
